import {
  CITY_MANAGEMENT_SUCCESS,
  CITY_MANAGEMENT_ERROR,
  CITY_MANAGEMENT_START,
  CITY_MANAGEMENT_ALL_SUCCESS,
  CITY_MANAGEMENT_COMING_SUCCESS,
  CITY_MANAGEMENT_POPULAR_SUCCESS,
  ADD_CITY_DATA_START,
  ADD_CITY_DATA_SUCCESS,
  ADD_CITY_DATA_ERROR,
  CITY_MANAGEMENT_DETAILS,
  CITY_MANAGEMENT_DETAILS_SUCCESS,
  CITY_MANAGEMENT_DETAILS_FAIL,
  CITY_MANAGEMENT_UPDATE,
  CITY_MANAGEMENT_UPDATE_SUCCESS,
  CITY_MANAGEMENT_UPDATE_FAIL,
  CITY_MANAGEMENT_DELETE,
  CITY_MANAGEMENT_DELETE_FAIL,
  CITY_MANAGEMENT_DELETE_SUCCESS,
  CITY_MANAGEMENT_CSV_START,
  CITY_MANAGEMENT_CSV_SUCCESS,
  CITY_MANAGEMENT_CSV_ERROR,
} from "../Constants/CityManagementConstant";

const initialState = {
  cityDataLoading: false,
  cityData: [],
  popularCityData: [],
  comingSoonCityData: [],
  allCityData: [],
  addCityData: [],
  addCityDataLoading: false,
  cityDetails: null,
  cityUpdateLoading: false,
  cityUpdate: [],
  cityDelete: false,
  loading: false,
};

export default function cityManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case CITY_MANAGEMENT_START:
      return {
        ...state,
        cityDataLoading: true,
      };
    case CITY_MANAGEMENT_SUCCESS:
      return {
        ...state,
        cityDataLoading: false,
        cityData: action.payload,
      };
    case CITY_MANAGEMENT_ERROR:
      return {
        ...state,
        cityDataLoading: false,
        cityData: [],
      };
    case CITY_MANAGEMENT_ALL_SUCCESS:
      return {
        ...state,
        allCityData: action.payload,
      };
    case CITY_MANAGEMENT_COMING_SUCCESS:
      return {
        ...state,
        comingSoonCityData: action.payload,
      };

    case CITY_MANAGEMENT_POPULAR_SUCCESS:
      return {
        ...state,
        popularCityData: action.payload,
      };

    case ADD_CITY_DATA_START:
      return {
        ...state,
        addCityDataLoading: true,
      };
    case ADD_CITY_DATA_SUCCESS:
      return {
        ...state,
        addCityDataLoading: false,
        addCityData: action.payload,
      };
    case ADD_CITY_DATA_ERROR:
      return {
        ...state,
        addCityDataLoading: false,
        addCityData: [],
      };
    case CITY_MANAGEMENT_DETAILS:
      return {
        ...state,
        cityDataLoading: true,
        cityDetails: null,
      };
    case CITY_MANAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        cityDataLoading: false,
        cityDetails: action.payload,
      };
    case CITY_MANAGEMENT_DETAILS_FAIL:
      return {
        ...state,
        cityDataLoading: false,
        cityDetails: null,
      };
    case CITY_MANAGEMENT_UPDATE:
      return {
        ...state,
        cityUpdate: true,
      };
    case CITY_MANAGEMENT_UPDATE_SUCCESS:
      return {
        ...state,
        cityUpdate: false,
        cityUpdate: action.payload,
      };
    case CITY_MANAGEMENT_UPDATE_FAIL:
      return {
        ...state,
        cityUpdate: false,
        cityUpdate: [],
      };
      case CITY_MANAGEMENT_DELETE:
        return {
          ...state,
          cityDelete: true,
        };
      case CITY_MANAGEMENT_DELETE_SUCCESS:
        return {
          ...state,
          cityDelete: false,
        };
      case CITY_MANAGEMENT_DELETE_FAIL:
        return {
          ...state,
          cityDelete: false,
        };
    case CITY_MANAGEMENT_CSV_START:
      return {
        ...state,
        loading: true,
      };
    case CITY_MANAGEMENT_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CITY_MANAGEMENT_CSV_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
